//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AppPermissionsViewDetails from "./AppPermissionsViewDetails.vue";
import { PERMISSIONS_ROLES, SIDEBAR_SUBROLES, PERMISSIONS_TABS_ROLES, PERMISSIONS_TABS, ROLES_CONSTRAINTS } from "./appPermissionsRolesConst";

export default {
    name: "AppPermissionsSetRoleList",
    components: {
        AppPermissionsViewDetails,
        AQModal,
        AQCheckbox
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        applicationId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            selectedPermissions: [],
            showModal: false,
            hoverIndex: null,
            currentRoleViewDetails: null,
            defaultPermissionsRoles: PERMISSIONS_ROLES,
            sidebarSubroles: SIDEBAR_SUBROLES,
            rolesConstraints: ROLES_CONSTRAINTS,
            allPermissions: [],
            dynamicPermissions: [],
            defaultTabsRoles: PERMISSIONS_TABS_ROLES,
            permissionsTabs: PERMISSIONS_TABS,
            selectedRoleTab: "building-tab",
            permissionTabsRole: {
                building: [],
                initiate: [],
                tasks: [],
                dataViews: [],
                analytics: [],
                settings: []
            }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.selectedPermissions = newValue;
            },
            immediate: true
        }
    },
    created() {
        this.getPermissionsRoles();
    },
    methods: {
        ...mapActions("apps", ["actGetPermissionsRoles"]),
        changeSelectedPermissions() {
            this.$emit("input", this.selectedPermissions);
        },
        viewDetails(data) {
            this.currentRoleViewDetails = data;
            this.showModal = !!data;
            this.$emit("detailsOpened", !!data);
        },
        getPermissionsRoles() {
            this.actGetPermissionsRoles(this.applicationId).then(
                ({ data }) => {
                    const dataViewsItems = [];
                    this.$emit("allPermissions", JSON.parse(JSON.stringify(data)));
                    this.allPermissions = data;
                    this.permissionTabsRole = { building: [], initiate: [], tasks: [], dataViews: [], analytics: [], settings: [] };

                    this.allPermissions.forEach(role => {
                        if (role.code !== "OWNER") {
                            if (this.defaultPermissionsRoles.includes(role.code)) {
                                const tabRole = this.defaultTabsRoles.find(({ code }) => code === role.code);
                                if (tabRole) {
                                    const type = this.permissionsTabs[tabRole.index];
                                    if (role.code === "TASKS_MANAGER") {
                                        this.permissionTabsRole[type].unshift(role);
                                    } else {
                                        this.permissionTabsRole[type].push(role);
                                    }
                                }
                            } else {
                                dataViewsItems.push(role);
                            }
                        }
                    });
                    this.permissionTabsRole.dataViews = [...this.permissionTabsRole.dataViews, ...dataViewsItems];
                    this.dynamicPermissions = dataViewsItems;
                    this.$emit("dynamicPermissions", this.dynamicPermissions);
                }
            );
        },
        getTitle(permission) {
            const { code, name, id } = permission;
            const getRoleName = () => (code === "INITIATOR" && id
                ? name : this.$t(`applicationPermissions.${code}Role`));
            return this.defaultPermissionsRoles.includes(code)
                ? getRoleName() : name;
        },
        getDescription(permission) {
            const { code, id } = permission;
            const removeDescription = code === "INITIATOR" && id;
            const customDescription = () => (this.$te(`applicationPermissions.${code}RoleDesc`) ? this.$t(`applicationPermissions.${code}RoleDesc`) : "");
            const getRoleDescription = () => (this.defaultPermissionsRoles.includes(code)
                ? customDescription() : this.$t("applicationPermissions.PerspectiveRoleDesc"));
            return removeDescription ? "" : getRoleDescription();
        }
    }
};
